<template>
	<div>
		<h1>Options Menu</h1>
		<table class="table table-bordered">
			<thead>
				<tr>
					<th>Label</th>
					<th>Value</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, i) in items" :key="i">
					<td>{{ item.label }}</td>
					<td>{{ item.value }}</td>
					<td>
						<a @click="removeItem(i)" class="fa fa-trash fa-2x text-danger" style="cursor: pointer"></a>
					</td>
				</tr>
			</tbody>
		</table>
	
		<hr/>

		<div class="row">
			<div class="col-md-6">
				<input class="form-control" v-model="newItem.label" placeholder="label">
			</div>
			<div class="col-md-6">
				<input class="form-control" v-model="newItem.value" placeholder="value">
			</div>
		</div>
		<br/>
		<a @click="addItem" class="fa fa-plus fa-2x text-info" style="cursor: pointer"> Add</a>
	</div>
</template>

<script>
	export default {
		props: ['commandResponse'],
		data() {
			return {
				newItem: {
					label: '',
					value: ''
				},
				items: this.commandResponse.resp_menu_extra_options || []
			}
		},
		methods: {
			addItem() {
				this.items.push(this.newItem)
				this.commandResponse.resp_menu_extra_options = this.items
				this.newItem = {
					label: '',
					value: ''
				}
			},

			removeItem(i) {
				this.items = this.items.filter((item, index) => {
					return index !== i
				});

				this.commandResponse.resp_menu_extra_options = this.items
			}
		},
		mounted() {
			//
		},
	}
</script>

<style lang="scss" scoped>
</style>
